// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-style[data-v-d1b5823a] {\n  height: 60vh;\n  padding-bottom: 50px;\n}\n[data-v-d1b5823a] .content-container {\n  height: 100%;\n}\n.content-scrollbar[data-v-d1b5823a] {\n  overflow-x: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
